import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M16.8 11.2c.8-.9 1.2-2 1.2-3.2a6 6 0 0 0-9.3-5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "m2 2 20 20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M6.3 6.3a4.67 4.67 0 0 0 1.2 5.2c.7.7 1.3 1.5 1.5 2.5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M9 18h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M10 22h4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "LightbulbOff";
const LightbulbOff = memo(themed(Icon));
export {
  LightbulbOff
};
//# sourceMappingURL=lightbulb-off.js.map
